import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch, RootState } from '../../redux/store';
import { fetchSystemInfo } from '../../redux/slices/systemInfoSlice';

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  const dispatch = useAppDispatch();
  const { version, loading, error } = useSelector((state: RootState) => state.systemInfo);

  useEffect(() => {
    dispatch(fetchSystemInfo());
  }, [dispatch]);

  const getBeVersion = () => {
    if (loading) return '...';
    if (error) return 'N/A';
    return version || 'N/A';
  };

  return (
    <footer className={classNames(className, 'footer')}>
      <Row className="g-1 justify-content-between align-items-center h-100">
        <Col xs={12} sm="auto" className="text-center">
          <p className="mb-0 mt-2 mt-sm-0 text-900">
            {import.meta.env.VITE_NAME}
            <span className="d-none d-sm-inline-block" />
            <span className="d-none d-sm-inline-block mx-1">|</span>
            <br className="d-sm-none" />
            {new Date().getFullYear()} &copy;{' '}
            <a href={import.meta.env.BASE_URL} target="_blank" rel="noreferrer">
              {import.meta.env.VITE_COMPANY_NAME}
            </a>
          </p>
        </Col>
        <Col xs={12} sm="auto" className="text-center">
          <p className="mb-0 text-600">
            FE v{import.meta.env.VITE_VERSION}
            <br />
            BE v{getBeVersion()}
          </p>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
